<!--  -->
<template>
  <div class="mass_box">
    <div class="addmass">
      <div class="addleftbox search_box">
        <el-input v-model="query.keywords" style="width:240px" placeholder="请输入公众号名称/appid/gh_id" />
        <el-select v-model="query.platform_id" filterable placeholder="请选择平台">
          <el-option
            v-for="item in accoutarr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select v-model="query.status" placeholder="请选择发送状态">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="query.send_date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择最后发送时间"
        />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
      <div><el-button icon="el-icon-plus" type="success" @click="addmass">新增群发</el-button></div>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="articles_template_name"
        label="模板名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="平台"
        width="100"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="公众号名称"
        width="100"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="appId"
        width="160"
        align="center"
      />
      <el-table-column
        prop="tag_name"
        label="标签组"
        align="center"
        width="280"
      >
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.account_names"> -->
          <el-tag
            v-for="(itemr,index) in scope.row.tag_group_names"
            :key="index"
            style="margin:5px 10px 0px 0px"
          >{{ itemr }}</el-tag>
          <!-- </div> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="发送状态"
        width="160"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" style="color:#E6A23C" class="el-icon-warning" />
          <i v-if="scope.row.status == 2" style="color:#E6A23C" class="el-icon-success" />
          <i v-if="scope.row.status == 3" class="el-icon-warning" />
          <i v-if="scope.row.status == 4" style="color:#F56C6C" class="el-icon-error" />
          <i v-if="scope.row.status == 5" style="color:#F56C6C" class="el-icon-warning" />
          <i v-if="scope.row.status == 6" style="color:#67C23A" class="el-icon-success" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="错误信息"
        width="160"
        align="center"
      />
      <el-table-column
        prop="send_hi_text"
        label="发送时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="cumulative_total"
        label="发送人数"
        width="100"
        align="center"
      />
      <el-table-column
        prop="send_date_text"
        label="最后发送时间"
        width="160"
        align="center"
      />
      <el-table-column
        prop="real_name"
        label="创建人"
        align="center"
        width="90"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
        width="160"
      />
      <el-table-column
        prop="created_at_text"
        label="操作"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editopenid(scope.row)">编辑常用openid</el-button>
          <el-button type="danger" size="mini" @click="deleter(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.status == 2" type="warning" size="mini" @click="stoppush(scope.row.id)">停止推送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="加入openid"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <addopenid ref="editoppidview" @updata="dialogVisible = false,accountlist()" />
    </el-dialog>
  </div>
</template>

<script>
import { timingpushArtcpreviewlist, timingstopsend, timingdelete, strategyPlatform } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addopenid from './components/addopenid.vue'
export default {
  components: { PaginationRight, addopenid },
  data() {
    return {
      tableData: [],
      total: null,
      query: {
        keywords: null,
        page: 1,
        pageSize: 10,
        status: null,
        platform_id: null,
        send_date: null
      },
      accoutarr: [],
      options: [{
        value: null,
        label: '全部'
      }, {
        value: 1,
        label: '正常(待发送)'
      }, {
        value: 2,
        label: '已经生成（定时发送中）'
      }, {
        value: 3,
        label: '已经取消'
      }, {
        value: 4,
        label: '生成失败'
      }, {
        value: 5,
        label: '有新记录强制取消'
      }],
      dialogVisible: false
    }
  },
  activated() {
    this.accountlist()
  },
  created() {
    this.accountlist()
    this.getstrategyplatform()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      const data = await timingpushArtcpreviewlist(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 获取平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.accoutarr = data.data.list
    },
    fetchPageSize(e) {
      this.query.pageSize = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    search() {
      this.query.page = 1
      this.accountlist()
    },
    reset() {
      this.query = {
        keywords: null,
        page: 1,
        pageSize: 10,
        status: null,
        platform_id: null,
        send_date: null
      }
      this.accountlist()
    },
    editopenid(item) {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.editoppidview.send(item)
      }, 100)
    },
    deleter(id) {
      this.$confirm('此操作将删除该推送, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        timingdelete({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.accountlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    stoppush(id) {
      this.$confirm('此操作将停止该推送, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        timingstopsend({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '停止成功!'
          })
          this.accountlist()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停止'
        })
      })
    },
    addmass() {
      this.$router.push({ path: '/masspollingList/index' })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.mass_box{
  padding: 30px;
}
.addmass{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.addleftbox{
  display: flex;
  align-items: center;
  gap:10px;
}
</style>
